import React from 'react';
const pilastri = [{
  emoji: '📚',
  title: '6 Volumi Annuali',
  desc: 'Unità di apprendimento mese per mese, coprendo tutti i livelli del Pilates.',
  color: 'bg-primary'
}, {
  emoji: '🩺',
  title: 'Protocolli Clinici',
  desc: 'Come agire in sicurezza di fronte a ernie, scoliosi e dolori comuni.',
  color: 'bg-secondary'
}, {
  emoji: '🤰',
  title: 'Popolazioni Speciali',
  desc: 'Guida pronta per Gestanti e Terza Età con adattamenti specifici.',
  color: 'bg-accent-sage'
}, {
  emoji: '🌊',
  title: 'Pianificazione "Flow"',
  desc: "L'arte delle transizioni per lezioni senza interruzioni e di alto livello.",
  color: 'bg-badge-red'
}];
const materiali = [{
  emoji: '📖',
  title: 'I 6 Volumi del Metodo (+200 pag)',
  desc: 'Guida completa con spiegazioni, disegni tecnici e progressioni logiche.'
}, {
  emoji: '📋',
  title: 'Registro di Valutazione Posturale (+40 pag)',
  desc: 'Griglie di osservazione e schede anamnestiche pronte da consegnare alle allieve.'
}, {
  emoji: '💪',
  title: 'Manuale Pilates "Dynamic" (+80 pag)',
  desc: 'Sequenze dinamiche che integrano forza, controllo e fluidità.'
}, {
  emoji: '🗂️',
  title: 'Il Raccoglitore (Schede Rapide)',
  desc: 'Mappe visuali da tenere accanto al tappetino per una consultazione rapida durante la classe.'
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-alt py-20 px-4" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <span className="text-4xl mb-4 block" data-id="element-27">🎁</span>
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4 tracking-tight" data-id="element-28">
            Cosa troverai all'interno?
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-29">
            Tutto ciò di cui hai bisogno in un unico Kit. Quattro pilastri di
            contenuto tecnico pensati per eliminare lo stress e far brillare le
            tue lezioni.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-20" data-id="element-30">
          {pilastri.map((item, i) => <div key={i} className="bg-white rounded-2xl border border-border-light overflow-hidden flex flex-col relative group hover:-translate-y-1 transition-transform duration-300 shadow-[0_4px_15px_rgba(201,137,155,0.05)]" data-id="element-31">
              <div className={`${item.color} h-1.5 w-full opacity-80`} data-id="element-32" />
              <div className="flex-1 flex flex-col p-8 relative" data-id="element-33">
                <div className={`absolute inset-0 ${item.color} opacity-[0.02] group-hover:opacity-[0.05] transition-opacity`} data-id="element-34"></div>
                <span className="text-4xl mb-4 block relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-35">
                  {item.emoji}
                </span>
                <h3 className="text-xl font-bold text-text-main leading-snug relative z-10 mb-2" data-id="element-36">
                  {item.title}
                </h3>
                <p className="text-text-sec text-base leading-relaxed relative z-10" data-id="element-37">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-3xl border border-border-light p-8 sm:p-12 shadow-[0_8px_30px_rgba(201,137,155,0.08)]" data-id="element-38">
          <div className="text-center mb-10" data-id="element-39">
            <span className="text-4xl mb-4 block" data-id="element-40">📦</span>
            <h3 className="text-2xl sm:text-4xl font-serif font-black text-text-main mb-4" data-id="element-41">
              Cosa riceverai immediatamente?
            </h3>
            <p className="text-text-sec text-lg" data-id="element-42">
              350+ pagine di materiale pronto all'uso. PDF pronti per la stampa
              (A4) o per l'uso digitale.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-43">
            {materiali.map((mat, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl hover:bg-bg-main transition-colors" data-id="element-44">
                <div className="text-3xl flex-shrink-0" data-id="element-45">{mat.emoji}</div>
                <div data-id="element-46">
                  <h4 className="font-bold text-text-main mb-1" data-id="element-47">{mat.title}</h4>
                  <p className="text-text-sec text-sm leading-relaxed" data-id="element-48">
                    {mat.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}